import { RailVisitResponseDto, RailVisitsApi } from '@planning/app/api'
import { createApiClient } from '@planning/app/http-client'
import { Event, IEvent, IQueryHandler, IQueryMessage } from '@tom-ui/utils'

export class GetRailVisitsByIdsQuery implements IQueryMessage {
  static type = 'GetRailVisitsByIdsQuery'
  type = GetRailVisitsByIdsQuery.type

  constructor(public ids: number[]) {}

  getKey = () => {
    return JSON.stringify(this)
  }
}

const httpClient = createApiClient(RailVisitsApi)

export const getRailVisitsByIdsQueryHandler: IQueryHandler<
  GetRailVisitsByIdsQuery,
  IEvent<RailVisitResponseDto[]>
> = async query => {
  const { data } = await httpClient.getByIds(query.ids)

  return new Event(GetRailVisitsByIdsQuery.type, data)
}
